const ES = {
    title: 'Clientes',
    table: {
        title: 'Listado de clientes',
        columns: {
            fullname: 'Nombre y apellido',
            document: 'INE',
            created: 'Alta',
            phone: 'N° de celular',
            status: 'Estado',
            actions: 'Acciones'
        },
        status: {
            1: 'Pendiente',
            2: 'Activo',
            3: 'Recupero',
            4: 'Bloqueado',
            5: 'Inactivo',
            title: 'Estado'
        },
        menu: {
            viewProfile: 'Ver perfil',
            unsubscribe: {
                title: 'Dar de baja',
                modal: {
                    title: 'Desea dar de baja al cliente',
                    date: 'Fecha',
                    reason: 'Motivo',
                    placeholder: 'Ej. Cambio de banco, mudanza, etc...',
                    warningEmpty: 'Debes ingresar un motivo de baja para continuar',
                    warningExcess: 'El limite de 100 caracteres se a excedido',
                    success: 'Se creó la petición de baja del cliente'
                }
            },
        }
    }
};

export default ES;
